import { memo } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";

function MarkAsCompleteCreatorFragmentDemo() {
  return (
    <Demo>
      <Name>MarkAsCompleteCreatorFragment</Name>
      <Highlight>
        <p>
          Mark as complete creator fragment - Component for marking tasks
          complete during creation
        </p>
      </Highlight>
    </Demo>
  );
}

export default memo(MarkAsCompleteCreatorFragmentDemo);
